var map = {
	"./win-sign.json": 103,
	"./win-sign@2x.json": 104
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 126;


//////////////////
// WEBPACK FOOTER
// ./themes/fq/sprite ^\.\/win\-sign.*\.json$
// module id = 126
// module chunks = d-game